/**
 * @generated SignedSource<<06b6c8a430c7c23d3a57a1b39b0f498d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Currency = "BRL" | "USD" | "%future added value";
export type ProjectStatus = "archived" | "completed" | "in_progress" | "%future added value";
export type ProjectsPageUpdateProjectMutation$variables = {
  color?: string | null | undefined;
  currency?: Currency | null | undefined;
  hourlyRate?: number | null | undefined;
  id: string;
  name?: string | null | undefined;
  status?: ProjectStatus | null | undefined;
};
export type ProjectsPageUpdateProjectMutation$data = {
  readonly updateProject: {
    readonly color: string | null | undefined;
    readonly currency: Currency;
    readonly hourlyRate: number;
    readonly id: string;
    readonly name: string;
    readonly status: ProjectStatus;
  };
};
export type ProjectsPageUpdateProjectMutation = {
  response: ProjectsPageUpdateProjectMutation$data;
  variables: ProjectsPageUpdateProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "color"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currency"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hourlyRate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "color",
        "variableName": "color"
      },
      {
        "kind": "Variable",
        "name": "currency",
        "variableName": "currency"
      },
      {
        "kind": "Variable",
        "name": "hourlyRate",
        "variableName": "hourlyRate"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "updateProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hourlyRate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectsPageUpdateProjectMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectsPageUpdateProjectMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "82a506765d1fa47e64adbb9a3b36457e",
    "id": null,
    "metadata": {},
    "name": "ProjectsPageUpdateProjectMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectsPageUpdateProjectMutation(\n  $id: ID!\n  $name: String\n  $hourlyRate: Float\n  $currency: Currency\n  $status: ProjectStatus\n  $color: String\n) {\n  updateProject(id: $id, name: $name, hourlyRate: $hourlyRate, currency: $currency, status: $status, color: $color) {\n    id\n    name\n    hourlyRate\n    currency\n    status\n    color\n  }\n}\n"
  }
};
})();

(node as any).hash = "e13d4f13f1baf08462c089cf7fffc362";

export default node;
